/**
 * Copyright 2022-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { checkArrayEquality } from '../utils/fns';
export class OdpConfig {
    constructor(apiKey, apiHost, pixelUrl, segmentsToCheck) {
        this.apiKey = apiKey;
        this.apiHost = apiHost;
        this.pixelUrl = pixelUrl;
        this.segmentsToCheck = segmentsToCheck;
    }
    /**
     * Detects if there are any changes between the current and incoming ODP Configs
     * @param configToCompare ODP Configuration to check self against for equality
     * @returns Boolean based on if the current ODP Config is equivalent to the incoming ODP Config
     */
    equals(configToCompare) {
        return (this.apiHost === configToCompare.apiHost &&
            this.apiKey === configToCompare.apiKey &&
            this.pixelUrl === configToCompare.pixelUrl &&
            checkArrayEquality(this.segmentsToCheck, configToCompare.segmentsToCheck));
    }
}
export const odpIntegrationsAreEqual = (config1, config2) => {
    if (config1.integrated !== config2.integrated) {
        return false;
    }
    if (config1.integrated && config2.integrated) {
        return config1.odpConfig.equals(config2.odpConfig);
    }
    return true;
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=odp_config.js.map